import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import ActionButton from "../ActionButton";
import instance from "../../store/actions/instance";
export class WaitList extends Component {
  state = {
    data: null,
  };

  handleClick = async () => {
    let request = await instance.get(
      `/api/waiting/track?tracking_id=${this.props.location.state.tracking_id}&waiting_list=${this.props.location.state.waiting_list.id}`
    );
    request = request.data;
    if (request.success) {
      this.setState({ data: request.data[0] });
    }
  };
  render() {
    window.scrollTo(0, document.body.scrollHeight);
    const language = this.props.language;
    let waiting_Spot = ``;
    let status = "";
    if (!this.props.location.state || !this.props.location.state.waiting_list) {
      this.props.history.replace("/");
      return null;
    } else {
      if (!this.state.data) {
        this.setState({ data: this.props.location.state.data });
      } else {
        waiting_Spot = `${this.state.data.position}`;
        status =
          language === "english"
            ? this.state.data.status.english.split("<br/>")
            : this.state.data.status.arabic.split("<br/>");
      }
    }
    let text_waitList = "Wait List";
    let text_tracking = "Tracking Code";
    let text_waitSpot = "Your Waiting Spot";
    let text_status = "Status";
    let text_waiting_time = "Estimated Waiting Time";
    if (language === "arabic") {
      text_waitList = "قائمة الإنتظار";
      text_waitSpot = "مكانك  في  قائمة الإنتظار";
      text_status = "الحالة";
      text_waiting_time = "الوقت المتبقى";
      text_tracking = "كود التتبع";
    }
    return (
      <>
        <div
          style={{ backgroundColor: "white", marginTop: "1.5rem" }}
          className="h-100  "
        >
          <ProductHeader
            style={{ backgroundColor: "white" }}
            onBack={() =>
              this.props.history.goBack({
                waiting_list: this.props.location.state.waiting_list,
              })
            }
          />
          <div
            className="free-space-58"
            style={{ backgroundColor: "white" }}
          ></div>

          <h1 className=" ">{text_waitList}</h1>
          <h3 className=" ">{text_waitSpot}</h3>
          <h1 className=" " style={{ color: "goldenrod", fontSize: "5rem" }}>
            {waiting_Spot}
          </h1>
          <h3 className="  ">{text_status}</h3>
          <h4
            className="  "
            style={{ color: "goldenrod", fontSize: "1rem", marginTop: "0px" }}
          >
            {status[0]}
          </h4>
          <h3 className="  ">{text_tracking}</h3>
          <h4
            className="  "
            style={{ color: "goldenrod", fontSize: "1rem", marginTop: "0px" }}
          >
            {this.props.history.location.state.tracking_id}
          </h4>
          {status[1] ? (
            <>
              <h3 className="  ">{text_waiting_time}</h3>
              <h4
                className=""
                style={{
                  color: "goldenrod",
                  fontSize: "1rem",
                  marginTop: "0px",
                  direction: language === "english" ? "ltr" : "rtl",
                }}
              >
                {status[1].split(":")[1]}
              </h4>
            </>
          ) : null}
        </div>
        <div
          className="free-space-115"
          style={{ backgroundColor: "white" }}
        ></div>

        <ActionButton
          onClick={() => this.handleClick()}
          action={this.props.language == "english" ? "Check" : "تحقق"}
          allowWithMenu
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(WaitList);
